import { Injectable, signal, computed } from '@angular/core';

export interface PaymentNavigationState {
    category: string;   // e.g. 'PolicyNumber', 'InvoiceNumber', 'AccountNumber'
    search: string;     // the reference number value
    zipcode: string;    // the mailing zip code
}

@Injectable({
    providedIn: 'root'
})
export class PaymentNavigationService {
    private state = signal<PaymentNavigationState | null>(null);

    readonly navigationState = this.state.asReadonly();

    readonly category = computed(() => this.state()?.category || '');
    readonly search = computed(() => this.state()?.search || '');
    readonly zipcode = computed(() => this.state()?.zipcode || '');

    setNavigationState(state: PaymentNavigationState): void {
        this.state.set(state);
    }

    clear(): void {
        this.state.set(null);
    }
}
